import { Injectable } from '@angular/core';
import {
    DatDbClientBatch,
    IDatDbResponseBatch,
    IDatDbResponseBatchRow,
} from './models';

@Injectable({
    providedIn: 'root',
})
export class DatDbClientMapperService {
    constructor() {}

    mapDatDbBatch(docs: IDatDbResponseBatch): DatDbClientBatch {
        return (
            docs?.rows?.reduce(
                (
                    currentBatch: DatDbClientBatch,
                    row: IDatDbResponseBatchRow
                ): DatDbClientBatch => {
                    return {
                        ...currentBatch,
                        [row.id]: row.doc.doc,
                    };
                },
                {}
            ) ?? {}
        );
    }
}
